import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=641bf3cd&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=js&"
export * from "./Balance.vue?vue&type=script&lang=js&"
import style0 from "./Balance.vue?vue&type=style&index=0&id=641bf3cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bf3cd",
  null
  
)

export default component.exports